module.exports = __webpack_public_path__ + "img/logoAUGv.af30c0f9.png";